import type { TCreateUserOutputDTO } from '@doutorsim/shared/users'

type AccessControlProps = {
  role: TCreateUserOutputDTO['userType'] | undefined
  renderIfAdmin?: React.ReactNode
  renderIfUser?: React.ReactNode
}

export const AccessControl = ({ role, renderIfAdmin, renderIfUser }: AccessControlProps) => {
  return (
    <>
      {role === 'staff' && renderIfAdmin}
      {role === 'tenant' && renderIfUser}
    </>
  )
}
